import { sendGetRequest } from '@/services/api.service'
import { GTR_CORE } from '@/config/api.config'

export const getClientApi = uuid => {
  return sendGetRequest(`${GTR_CORE.BASE_API_URL}${GTR_CORE.CLIENTS}/${uuid}`)
}
